import type { HelpFile } from '../../types/help'
import { CertificationPoliciesTestIds } from '../../../testids/CertificationPoliciesTestIds'

export const certificationPoliciesHelp: HelpFile = {
  docPage: '/docs/governance/certification-policies',
  texts: {
    [CertificationPoliciesTestIds.certificationPoliciesList]: 'Certification policies define recurring campaign templates — scope, schedule, and reviewer assignment.',
    [CertificationPoliciesTestIds.btnCreatePolicy]: null,
    [CertificationPoliciesTestIds.colName]: null,
    [CertificationPoliciesTestIds.colPriority]: 'Policies are evaluated in ascending priority order — lower numbers run first.',
    [CertificationPoliciesTestIds.colConditions]: 'Number of scope conditions that define which identities and access profiles this policy covers.',
    [CertificationPoliciesTestIds.colFrequency]: 'How often campaigns are automatically generated from this policy.',
    [CertificationPoliciesTestIds.colStatus]: null,
  },
}
